import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {demoImages} from '../demoData';
import {openDemoImage, closeDemoImage} from '../actions/DemoActions';
import findIndex from 'lodash/findIndex';
import {onToggleSelectImageDemo} from '../actions/ImageActions';
import {onImageViewerToggleOriginalDemo} from '../actions/PresetActions';
import Workspace from '../components/Workspace';
import ContainerDimensions from 'react-container-dimensions';
import {nextIndex, prevIndex} from '../utils';

@connect(state => ({demo: state.demo}), {
    openDemoImage,
    closeDemoImage,
    onToggleSelectImage: onToggleSelectImageDemo,
    onImageViewerToggleOriginal: onImageViewerToggleOriginalDemo,
})
export default class DemoImageViewerContainer extends Component {
    static propTypes = {
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string
            }),
        }),
        demo: PropTypes.object,
        onToggleSelectImage: PropTypes.func,
        onImageViewerToggleOriginal: PropTypes.func,
    };

    componentWillMount() {
        this.loadDemoImage(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.loadDemoImage(nextProps);
        }
    }

    loadDemoImage = (props) => {
        const {match: {params: {id}}} = props;
        props.openDemoImage(parseInt(id, 10));
    };

    render() {
        const {demo} = this.props;
        const {id, isOriginalActive, selectedImages} = demo;
        if (!id) {
            return false;
        }

        const sortedSelectedImages = [...selectedImages].sort();

        const idx = findIndex(demoImages, ['id', id]);
        if (idx === -1) {
            return false;
        }
        const imageInfo = demoImages[idx];
        const pIdx = prevIndex(idx, demoImages.length);
        const nIdx = nextIndex(idx, demoImages.length);
        const prevId = demoImages[pIdx].id;
        const nextId = demoImages[nIdx].id;
        return (
            <ContainerDimensions>{({width, height}) => (
                <Workspace
                    urlPrefix="/demo"
                    galleryUrl="/demo"
                    images={demoImages}
                    imageInfo={imageInfo}
                    selectedImages={sortedSelectedImages}
                    onSelect={this.props.onToggleSelectImage}
                    isOriginalActive={isOriginalActive}
                    onImageViewerToggleOriginal={this.props.onImageViewerToggleOriginal}
                    isDemo={true}
                    hasOpenModal={() => false}
                    width={Math.round(width)}
                    height={Math.round(height)}
                    prevId={prevId}
                    nextId={nextId}
                    currIdx={idx}
                    onCloseImage={this.props.closeDemoImage}
                />
            )}</ContainerDimensions>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/DemoImageViewerContainer.js